var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { BaseButton } from "../base-button/BaseButton";
import { IdButtonType } from "../base-button/IdButtonType";
export var ButtonPrimary = React.memo(function (props) { return (React.createElement(BaseButton, __assign({ name: IdStyles.ButtonPrimary, styleId: IdButtonType.ButtonRectangleExtraLarge }, props))); });



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/common/ButtonPrimary.tsx
// module id = 27
// module chunks = 3